export default __webpack_public_path__ + "static/media/guitar_tattoo.8d7c47d5.jpg";